import { LoadingOverlay, Text } from '@mantine/core';

import ModalContent from '../ModalContent';

interface Props {
  onClose: () => void
  onClick: () => void
  loading: boolean
}
const ResetOutline: React.FC<Props> = (props: Props) => {
  const { onClose, onClick, loading } = props;
  return <ModalContent
    title='Reset outline'
    primaryButton={{
      label: 'Reset',
      disabled: loading,
      onClick
    }}
    secondaryButton={{
      label: 'Close',
      disabled: loading,
      onClick: onClose
    }}
  >
    <LoadingOverlay visible={loading} />
    <Text>
      Resetting your outline will replace your current one.
      Any previously sorted requirements will need to be re-sorted.
    </Text>
  </ModalContent>;
};

export default ResetOutline;
